import ingredient from './modules/ingredient'
import language from './modules/language'
import dashBoard from './modules/dashBoard'
import navigationDrawer from './modules/NavigationDrawer'
import statement from './modules/statement'
import queuePage from './modules/queuePage'
import appointment from './modules/appointmentSchedule'
import patient from './modules/patient'
import opdreport from './modules/OpdReport'
import drugFormula from './modules/drugFormula'
import product from './modules/product'
import stock from './modules/stock'
import pos from './modules/pos'
import course from './modules/course'
import doctorModel from './modules/doctor'
import service from './modules/service'
import room from './modules/room'
import auth from './modules/auth'

export default {
  ingredient,
  language,
  dashBoard,
  navigationDrawer,
  statement,
  queuePage,
  appointment,
  patient,
  opdreport,
  drugFormula,
  product,
  stock,
  course,
  pos,
  doctorModel,
  service,
  room,
  auth,
  doctor: 'Doctor',
  assistantDoctor: 'Assistant Doctor',
  TreatingDoctor: 'Treating Doctor',
  examiningDoctor: 'Examining Doctor',
  name: 'First Name',
  lastname: 'Last Name',
  nameLastName: 'Full Name',
  print: 'Print',
  img: 'Image',
  phone: 'Mobile',
  call: 'Call',
  tel: 'Phone Number',
  signature: 'Signature',
  signatory: 'Signatory',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  email: 'Email',
  doctorName: 'Doctor Name',
  patientName: 'Patient Name',
  inPatient: 'Inpatient',
  outPatient: 'Outpatient',
  confirmDeletePatient: 'Confirm Delete Patient',
  confirmPatientDeletionPrompt: 'You are about to delete a patient. Do you want to continue?',
  customer: 'Customer',
  searchDoctor: 'Search Doctor Name',
  searchPatientName: 'Search Patient Name in System',
  selectDoctor: 'Select Doctor',
  selectedBed: 'Select Bed',
  selectAssistant: 'Select Assistant Doctor',
  selectedClinic: 'Select Your Clinic',
  selectTreatingDoctor: 'Select Treating Doctor',
  plzEnterData: 'Please enter data',
  plzSelectData: 'Please select data',
  plzSelectDate: 'Please select date',
  status: 'Status',
  selectStatus: 'Select status',
  type: 'Type',
  selectType: 'Select type',
  selectedPurchaseOrderType: 'Select purchase order type',
  selectDate: 'Select date',
  examinationDate: 'Examination Date',
  age: 'Age',
  create: 'Create data',
  create0: 'Create',
  edit: 'Edit data',
  delete: 'Delete data',
  setting: 'Settings',
  editAccount: 'Edit account',
  editProductUnit: 'Edit product unit data',
  save: 'Save',
  recorder: 'Recorder',
  ok: 'OK',
  completed: 'Completed',
  confirm: 'Confirm',
  cancel: 'Cancel',
  back: 'Back',
  backToHome: 'Back to Home',
  symptom: 'Symptom',
  logout: 'Logout',
  searchPatientOPDList: 'Search patient, OPD list',
  price: 'Price',
  salePrice: 'Sale price',
  bath: 'Baht',
  total: 'Total',
  cashPortion: 'Discount',
  placeholder: {
    enterName: 'Enter first name',
    enterNameEN: 'Enter first name (English)',
    enterLastName: 'Enter last name',
    enterLastNameEN: 'Enter last name (English)',
    selectCustomer: 'Select customer',
    selectPatient: 'Select patient',
    enterTel: 'Enter phone number',
    searchPatientIdName: 'Search patient ID, patient name',
    selectPrefix: 'Select prefix',
    gender: 'Select gender',
    selectVerifyDay: 'Select examination date',
    examinationLocation: 'Examination location',
    prefixEn: 'Select prefix (English)',
    addressDetail: 'Enter address details',
    detailsAreAsFollows: 'Details are as follows',
    subdistrict: 'Enter subdistrict',
    district: 'Enter district',
    province: 'Enter province',
    postCode: 'Enter postal code',
    country: 'Select country',
    plzEnterCorrectEmail: 'Please enter a valid email',
    registrationEmail: 'Please enter the email you registered with',
    addPrefix: 'Add prefix',
    addPrefixEn: 'Add prefix(EN)',
    addGender: 'Add gender',
    addBloodType: 'Add blood type',
    addChannelsToKnow: 'Add channels to know'
  },
  label: {
    time: 'Time',
    seconds: 'Seconds',
    hour: 'Hour',
    timeStop: 'Stop time',
    day: 'Day',
    to: 'To',
    countdown: 'Countdown',
    wait: 'Wait',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    toDay: 'Today',
    DMY: 'Day-Month-Year',
    stop: 'Stop',
    start: 'Start',
    formDay: 'From date',
    verifyDay: 'Date of examination',
    treatmentDate: 'Treatment date',
    createDocDate: 'Document creation date',
    issuedDate: 'Issued on date',
    andOnDate: 'And on date',
    examinationStartTime: 'Examination start time',
    examinationEndTime: 'Examination end time',
    prefix: 'Prefix',
    prefixEn: 'Prefix (EN)',
    TimeToCreateExamination: 'Time of previous examination creation',
    duty: 'Duty of',
    emContact: 'Emergency contact',
    search: 'Search',
    add: 'Add'
  },
  toolTip: {
    queuePage: 'Queue page',
    addPatient: 'Add patient information',
    appointmentTable: 'Patient appointment table',
    nextAppointment: 'Next appointment',
    createUser: 'Create user',
    addProductAndFormula: 'Add product and formula'
  },
  address: {
    address: 'Address',
    contactAddress: 'Contact address',
    addressDetail: 'Address details',
    subdistrict: 'Subdistrict',
    district: 'District',
    province: 'Province',
    postCode: 'Postal code',
    citizenId: 'Citizen ID',
    country: 'Country'
  },
  shortAddress: {
    s: 'Subdistrict',
    d: 'District',
    p: 'Province'
  },
  prefix: {
    mr: 'Mr.',
    iAm: 'I am',
    mrs: 'Mrs.',
    miss: 'Miss',
    dr_male: 'Dr. (male)',
    dr_female: 'Dr. (female)',
    mr_mrs_miss: '(Mr., Mrs., Miss)'
  },
  alert: {
    noDataSearch: 'No data found'
  },
  modal: {
    create: {
      success: 'Create data success !'
    },
    edit: {
      success: 'Edit data success !'
    },
    delete: {
      success: 'Delete data success !',
      subTitle: 'You are about to delete data. Do you want to continue?'
    }
  }
}
